import React from 'react';
import { motion } from 'framer-motion';

const BMIChart = ({ currentBmi }) => {
  const ranges = [
    { label: 'Underweight', min: 0, max: 18.5, color: 'bg-blue-500' },
    { label: 'Normal', min: 18.5, max: 25, color: 'bg-green-500' },
    { label: 'Overweight', min: 25, max: 30, color: 'bg-yellow-500' },
    { label: 'Obese', min: 30, max: 40, color: 'bg-red-500' }
  ];

  const getIndicatorPosition = (bmi) => {
    if (!bmi) return 0;
    const clampedBmi = Math.min(Math.max(bmi, 15), 40);
    return ((clampedBmi - 15) / 25) * 100;
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-2xl shadow-xl p-8"
    >
      <h3 className="text-xl font-bold text-gray-800 mb-6">BMI Scale</h3>
      
      <div className="relative">
        {/* BMI Scale */}
        <div className="flex rounded-lg overflow-hidden h-8 mb-4">
          {ranges.map((range, index) => (
            <div
              key={index}
              className={`${range.color} flex-1 relative`}
              style={{
                flexBasis: `${((range.max - range.min) / 25) * 100}%`
              }}
            >
              <div className="absolute inset-0 flex items-center justify-center text-white text-xs font-medium">
                {range.label}
              </div>
            </div>
          ))}
        </div>

        {/* Current BMI Indicator */}
        {currentBmi && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            className="relative h-2 mb-2"
          >
            <div
              className="absolute w-4 h-4 bg-gray-800 rounded-full transform -translate-x-2 -translate-y-1 shadow-lg"
              style={{ left: `${getIndicatorPosition(currentBmi)}%` }}
            >
              <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white px-2 py-1 rounded text-xs font-medium">
                {currentBmi}
              </div>
            </div>
          </motion.div>
        )}

        {/* Scale Labels */}
        <div className="flex justify-between text-xs text-gray-500 mt-2">
          <span>15</span>
          <span>20</span>
          <span>25</span>
          <span>30</span>
          <span>35</span>
          <span>40</span>
        </div>
      </div>

      <div className="mt-6 p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-800">
          <strong>Note:</strong> BMI is a screening tool and doesn't directly measure body fat. 
          Consult with healthcare professionals for comprehensive health assessment.
        </p>
      </div>
    </motion.div>
  );
};

export default BMIChart;